export const BannerInformation = () => {
  return (
    <div className="bg-gradient-to-r from-[#F9F383] via-[#F14553] to-[#19477E] px-4 py-2 text-center">
      <p className="font-medium text-white">
        Reprise des cours le 1er septembre 2026 🥋
      </p>
    </div>
  );
};
